import { useDetailApi } from "../../../swr/useApi";
import { changeRequestsService } from "../../api_client";
import type { ChangeRequestDto } from "../../../api";

export function useChangeRequestDetails(id: string | undefined) {
  return useDetailApi<ChangeRequestDto>({
    key: id ? `change-request-details-${id}` : null,
    serviceMethod: async () => await changeRequestsService.getChangeRequest(id!),
  });
}
